import { RootState } from "../../core/rootReducers";

export const selecti18nState = (state: RootState) => state.i18n;

export function selectCurrentLocale(state: RootState): string | undefined {
	const i18nState = selecti18nState(state);
	return i18nState.locale;
}
